import { render, staticRenderFns } from "./HomeOTXFeed.vue?vue&type=template&id=c1df68c8&scoped=true"
import script from "./HomeOTXFeed.vue?vue&type=script&lang=js"
export * from "./HomeOTXFeed.vue?vue&type=script&lang=js"
import style0 from "./HomeOTXFeed.vue?vue&type=style&index=0&id=c1df68c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1df68c8",
  null
  
)

export default component.exports